import { useState } from 'react';
import Navbar from '../../components/Navbar';
import useStrategyData from '../../hooks/useStrategyData';
import StrategyCard from '../../components/StrategyCard';
import StrategyModal from '../../components/StrategyModal';
import SummaryBar from '../../components/SummaryBar/index.jsx';

const Backtests = () => {
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const accountId = '1'

  const { filteredStrategies, logoMap, loading } =
    useStrategyData(accountId, false); // `true` = last 24h

const backtestsStrategies = filteredStrategies.filter(s => s.strategy_type === 'BACKTESTS');


  return (
    <>
      <Navbar />

      {loading ? (
        <div className="container">⏳ Ładowanie strategii...</div>
      ) : filteredStrategies.length === 0 ? (
        <div className="container">⚠️ Nie masz żadnych strategii!</div>
      ) : (
        <>
<SummaryBar
  deposit={backtestsStrategies.reduce((sum, s) => sum + parseFloat(s.deposit || 0), 0)}  
  invested={backtestsStrategies.reduce((sum, s) => sum + parseFloat(s.usd_in_trade || 0), 0)}
  profit={backtestsStrategies.reduce((sum, s) => sum + parseFloat(s.withdrawable_profit || 0), 0)}
  roi={
    backtestsStrategies.length
      ? backtestsStrategies.reduce((sum, s) => sum + parseFloat(s.annual_roi || 0), 0) / backtestsStrategies.length
      : 0
  }
/>


          <div className="container cards-wrap">
  {[...backtestsStrategies].map(strategy => {
    const symbol = (strategy.symbol?.includes('/') ? strategy.symbol.split('/')[0] : strategy.symbol || '').toLowerCase();
    const logoUrl = logoMap[symbol] || '';

    return (
      <StrategyCard
        key={strategy.strategyId}
        strategy={strategy}
        logoUrl={logoUrl}
        onClick={() => {
          setSelectedStrategy({ ...strategy, _logoUrl: logoMap[symbol] || '' });
          setShowModal(true);
        }}
      />
    );
  })}
</div>

          {showModal && (
            <StrategyModal
              strategy={selectedStrategy}
              logoUrl={
                selectedStrategy?.symbol?.includes('/')
                  ? logoMap[selectedStrategy.symbol.split('/')[0].toLowerCase()]
                  : ''
              }
              onClose={() => setShowModal(false)}
            />
          )}
        </>
      )}
    </>
  );
};

export default Backtests;
